import React from 'react';
import { Service } from '../../types';
import ScrollToTopLink from '../../components/ScrollToTopLink';
import { ArrowLeft } from 'lucide-react';

interface ServiceTemplateProps {
  service: Service;
}

const ServiceTemplate: React.FC<ServiceTemplateProps> = ({ service }) => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <ScrollToTopLink
        to="/services"
        className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-8"
      >
        <ArrowLeft className="mr-2" size={20} />
        Retour aux services
      </ScrollToTopLink>

      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="relative h-64 md:h-96">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="p-6 md:p-8">
          <div className="flex items-center mb-6">
            {React.createElement(service.icon, { size: 32, className: "text-blue-600 mr-4" })}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">{service.title}</h1>
          </div>

          <p className="text-xl text-gray-600 mb-8">{service.description}</p>

          {service.longDescription && (
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Description détaillée</h2>
              {service.longDescription.map((paragraph, index) => (
                <p key={index} className="text-gray-600 mb-4">{paragraph}</p>
              ))}
            </div>
          )}

          {service.features && (
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Caractéristiques</h2>
              <ul className="list-disc list-inside space-y-2">
                {service.features.map((feature, index) => (
                  <li key={index} className="text-gray-600">{feature}</li>
                ))}
              </ul>
            </div>
          )}

          {service.benefits && (
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Avantages</h2>
              <ul className="list-disc list-inside space-y-2">
                {service.benefits.map((benefit, index) => (
                  <li key={index} className="text-gray-600">{benefit}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="mt-16 text-center border-t pt-8">
            <ScrollToTopLink
              to="/contact#contact-form"
              className="inline-flex items-center justify-center w-full md:w-auto bg-blue-600 text-white px-12 py-4 rounded-md text-lg font-semibold hover:bg-blue-700 transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              Demandez un devis gratuit →
            </ScrollToTopLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceTemplate; 